import React, { useEffect, useState, useRef } from 'react'
import { Badge } from 'antd';

import styles from './style.module.less';

export default function BlinkingBadge(props) {
  const { count = 0, style = {} } = props;

  const [flicker, setFlicker] = useState(false);
  const flickerTimer = useRef();

  const init = () => {
    if (!count) {
      return false
    }
    clearInterval(flickerTimer.current)
    flickerTimer.current = setInterval(() => {
      setFlicker(v => !v)
    }, 600);
  }
  useEffect(() => {
    init()
  }, [count])
  useEffect(() => {
    init()
    return () => {
      clearInterval(flickerTimer.current)
    }
  }, [])

  return (
    <>
      {(count && count > 0) ? <div className={styles.box}>
        <Badge count={flicker ? count : 0}
          style={style} >
        </Badge>
      </div> : ''}
    </>
  );
}
